import { observer } from 'mobx-react-lite';

import { useRumTrackingConsent } from '../hooks/use-rum-tracking-consent';
import { useRumUser } from '../hooks/use-rum-user';
import { useRumViewName } from '../hooks/use-rum-view-name';

/**
 * Renders nothing. Owns the post-init RUM side effects: naming views after the
 * Next route template, honouring an explicit analytics refusal, and
 * consent-gated user identification.
 *
 * `init` itself happens at module scope in `_app.page.tsx`, before React
 * renders, so no early vitals are missed.
 *
 * `observer` because `useAuth().viewer` is a MobX observable — without it this
 * never re-renders when the user query resolves, and the session stays
 * anonymous for authenticated users.
 */
export const Rum = observer(function Rum() {
  useRumViewName();
  useRumTrackingConsent();
  useRumUser();

  return null;
});
